<template>
    <div>
        <!-- THE BUTTON! -->
        <TB
            @TopupButton="TopupFund()"
            :ShowTopupButton=false
            @RedemptionButton="RedeemFund()"
            :ShowRedemptionButton=true
            @SwitchingButton="SwitchFund()"
            :ShowSwitchingButton=false
        />
        <!-- Topup Modal Dialog -->
      <!--   <q-dialog persistent v-model="TopupModal" transition-show="rotate" transition-hide="rotate">
            <q-card style="width:400px;">
                <q-form @submit="AddtoCart_Buy()" class="q-gutter-md">
                    <q-card-section>
                    <div class="text-h6 text-center">INVEST</div>
                    </q-card-section>

                    <q-card-section>
                        <FTB 
                            ref="refFTB"
                            :MinAddAmount=MinAddAmount
                            :MaxSalesCharge=MaxSalesCharge
                            :Currency="FundCurrency"
                            :Plan="Plan"
                        />
                    </q-card-section>

                    <q-card-actions align="right">
                        <q-btn label="Cancel" v-close-popup />
                        <q-btn type="submit" label="Add to Cart" color="primary"/>
                    </q-card-actions>
                </q-form>
            </q-card>
        </q-dialog> -->
        <!-- Redemption Modal Dialog -->
        <q-dialog persistent v-model="RedemptionModal" >
            <q-card style="width:600px; border-radius: 1rem;">
                <q-form @submit="AddtoCart_Redemption()">
                    <q-card-section>
                        <!-- <div class="text-h6 text-center"><q-chip square color="primary" :label='$t("Redeem.redeem")'  text-color="white"/></div> -->
                        <!-- <div class="text-h6 text-center" style="text-transform: uppercase; font-weight: bold; letter-spacing: 2px"> {{ $t("Redeem.redeem") }}</div> -->
                        <div class="q-pt-sm q-px-sm">
                            <div class="text-bold" style="font-size: 16px; padding-bottom: 10px">{{ $t("Redeem.redeem") }}</div>
                            <q-separator style="width: auto;"/>
                        </div>
                    </q-card-section>

                    <q-card-section style="padding-bottom: 0px; padding-top: 0px">
                        <FTR 
                        ref="refFTR" 
                        :BalanceUnit=BalanceUnit
                        :BalanceAmount=Amount
                        :Plan=Plan
                        :NAV=NAV
                        :NAVDate=NAVDate
                        :FundName=FundName
                        />
                        <!-- <FTRPRS 
                        ref="refFTRPRS" 
                        v-else-if="AccountType==='PRS'"
                        :BalanceUnitA=BalanceUnitA
                        :BalanceUnitB=BalanceUnitB
                        :BalanceAmount=Amount
                        :Plan=Plan
                        /> -->
                    </q-card-section>

                    <q-card-actions align="right" class="q-ma-md">
                        <q-btn :label='$t("common.cancel")' unelevated v-close-popup />
                        <q-btn :label='$t("Buy.AddToCart")' unelevated type="submit" text-color="white" style="background-color: #ff6666"/>
                    </q-card-actions>
                </q-form>
            </q-card>
        </q-dialog>
        <!-- SwitchingModal Dialog -->
       <!--  <q-dialog persistent v-model="SwitchingModal" transition-show="rotate" transition-hide="rotate">
            <q-card style="width:400px;">
                <q-form @submit="AddtoCart_Switching()" class="q-gutter-md">
                    <q-card-section>
                    <div class="text-h6 text-center">SWITCH</div>
                    </q-card-section>

                    <q-card-section>
                        <SATProfileDetails class="q-pb-sm"/>
                        <FTSW 
                        ref="refFTSW" 
                        :BalanceUnit=BalanceUnit
                        :Plan=Plan
                        />
                    </q-card-section>

                    <q-card-actions align="right">
                        <q-btn label="Cancel" v-close-popup />
              
                        <q-btn label="Add to Cart" color="primary" type="submit" />
                    </q-card-actions>
                </q-form>
            </q-card>
        </q-dialog> -->
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TB from "./TransactionButtons";
//import FIInfo from './FundInvestmentInfo'
//import FIInfo from './FundInvestmentInfoPrototype'
//import FTS from './FundTransactionSell'
import FTR from './FundTransactionRedemptionPrototype'
//import FTRPRS from './FundTransactionRedemptionPRS'
//import FTSPRS from './FundTransactionSellPRS'
import store from '../store';
import { date } from 'quasar';
export default {
    name: 'FundTransaction',
    components: {
        TB,
        FTR,
       // FTRPRS       
        //FIInfo,
       // FTS,
       // FTSPRS,
    },
    props: ['Plan','FundCurrency','FundName','SchemeName', 'Scheme','Amount','BalanceUnit','BalanceUnitA','BalanceUnitB','2','ProductType','AccountType', 'NAV', 'NAVDate'],
    data() {
        return {
            TopupModal : false,
            SellModal : false,
            RedemptionModal : false,
            SwitchingModal : false,
            BuyNewFundModal : false,  
            StoreStateCD : store.state.CD,
            StoreStateLogin: store.state.Login,
            StoreStateLookup : store.state.Lookup,
            StoreStateT : store.state.Transactions,   
            TransactionId : '',
            MinAddAmount : 0,
            MaxSalesCharge : 0,
            tempCountLength:0,
        }
    },
    
    methods : {
        ...mapActions([
            "PostTransaction",
            "FindMinimumTransaction",
            "FindMaximumSalesCharge"
        ]),
        TopupFund(){
            this.FindMinimumTransaction({
                Scheme : this.Scheme
            })
            .then(res=>{
                this.MinAddAmount = res.MinimumAdditionalAmount;
                this.FindMaximumSalesCharge({
                    Scheme : this.Scheme,
                    Plan : this.Plan
                })
                .then(res=>{
                    this.MaxSalesCharge = res.MaximumSalesCharge;
                    if(
                        this.StoreStateCD.SAT.InvestmentObjective.value===''
                        || this.StoreStateCD.SAT.InvestmentPeriod.value===''
                        || this.StoreStateCD.SAT.EstimatedNetWorth.value===''
                        || this.StoreStateCD.SAT.EstimatedLiability.value===''
                        || this.StoreStateCD.SAT.AnnualisedGain.value===''
                        || this.StoreStateCD.SAT.Age.value===''
                        || this.StoreStateCD.SAT.AnnualIncome.value===''
                        || this.StoreStateCD.SAT.RiskTolerance.value===''
                        || this.StoreStateCD.SAT.Bonds===''
                        || this.StoreStateCD.SAT.Derivatives===''
                        || this.StoreStateCD.SAT.Equities===''
                        || this.StoreStateCD.SAT.UTF==='' 
                    ){
                        this.$q.dialog({
                            title: 'Message',
                            message: 'Kindly complete Suitability Assessment.',
                        })
                        .onOk(() => {
                            this.$router.push({name : 'sat'})
                        }).onCancel(() => {
                            
                        })
                        
                    }
                    else{
                        this.TopupModal = true;
                        setTimeout(() => {
                            this.$refs.refFTB.Form.SalesCharge = this.MaxSalesCharge
                            this.$refs.refFTB.Form.InvAmount = this.MinAddAmount
                        }, 500)
                    }
                })
            })
        },
        GoToSAT(){
            this.$router.push({name:"sat"})
        },
        RedeemFund(){       
            for(var i=0; i < this.StoreStateLookup.Schemes_LK_2.length; i++){

                if(this.Scheme==this.StoreStateLookup.Schemes_LK_2[i].Scheme){
                    this.StoreStateT.Transaction.minRedemption = this.StoreStateLookup.Schemes_LK_2[i].minredeemunits
                    this.StoreStateT.Transaction.minAccountBalance = this.StoreStateLookup.Schemes_LK_2[i].minaccountbalance
                }
            }

            this.RedemptionModal = true;
        },
        SwitchFund(){
            if(
                this.StoreStateCD.SAT.InvestmentObjective.value===''
                || this.StoreStateCD.SAT.InvestmentPeriod.value===''
                || this.StoreStateCD.SAT.EstimatedNetWorth.value===''
                || this.StoreStateCD.SAT.EstimatedLiability.value===''
                || this.StoreStateCD.SAT.AnnualisedGain.value===''
                || this.StoreStateCD.SAT.Age.value===''
                || this.StoreStateCD.SAT.AnnualIncome.value===''
                || this.StoreStateCD.SAT.RiskTolerance.value===''
                || this.StoreStateCD.SAT.Bonds===''
                || this.StoreStateCD.SAT.Derivatives===''
                || this.StoreStateCD.SAT.Equities===''
                || this.StoreStateCD.SAT.UTF==='' 
            ){
                this.$q.dialog({
                    title: 'Message',
                    message: 'Kindly complete Suitability Assessment.',
                })
                .onOk(() => {
                    this.$router.push({name : 'sat'})
                }).onCancel(() => {
                    
                })
            }
            else{
                this.SwitchingModal = true;
            }
        },
        AddtoCart_Redemption(){

            
            var SelItem = this.$refs.refFTR;
            var currentBalanceUnit = 0 ;
            var allow = false;
            for(var j=0; j<this.StoreStateCD.Holdings.length; j++){
                if(this.StoreStateCD.Holdings[j].Scheme==this.Scheme ){
                    
           
                    var tempAmount =""
                    tempAmount=SelItem.Form.Units.replace(",","");
                   //console.log('1 - >' + tempAmount)
                    tempAmount=tempAmount.replace(",","");
                   // console.log('2 - >' +tempAmount )
                    tempAmount= tempAmount.trim() 
                    //console.log('3 - >' +tempAmount )
                    parseFloat(tempAmount).toFixed(2)
                   //console.log('4 - >' + tempAmount)

                    currentBalanceUnit= this.StoreStateCD.Holdings[j].BalanceUnit - tempAmount

                }
            }
            
            var toRedeemUnit = SelItem.Form.Units
            toRedeemUnit=toRedeemUnit.replace(",","").replace(",","");
            toRedeemUnit=toRedeemUnit.replace(",","").replace(",","");

            var beforeRedeemBalance = SelItem.Form.BalanceUnit
            
            var minRedemption = this.StoreStateT.Transaction.minRedemption
            var minAccountBalance =  this.StoreStateT.Transaction.minAccountBalance

            if(beforeRedeemBalance === undefined){
                beforeRedeemBalance = 0
            }

        if(parseFloat(currentBalanceUnit) != 0 ){
            if( parseFloat(currentBalanceUnit) >= parseFloat(minAccountBalance)){
                if(parseFloat(toRedeemUnit) < parseFloat(minRedemption)){
                    this.$q.notify({
                    message: this.$t("Redeem.msg1") + minRedemption  +this.$t("Redeem.msg2")  ,
                    color: 'red'
                })
            }
            else{ 
                allow = true;
            }
            }else if((parseFloat(beforeRedeemBalance) < parseFloat(minAccountBalance)) || (parseFloat(currentBalanceUnit) < parseFloat(minAccountBalance))){
                
                this.$q.notify({
                    message: this.$t("Redeem.msg3") +  + minAccountBalance  + this.$t("Redeem.msg4") ,
                    color: 'red'
                })
            }
        }else{
            
            allow = true;
        }
            

            if(allow == true){
                this.$q.loading.show({
                    spinnerSize: 50

                })
                this.RedemptionModal = false;
                var SelItem = this.$refs.refFTR;
                
                if((this.TransactionId === 0)||(this.TransactionId==='')){

                    this.CreateTempId();
                }
                this.CreateFundTransaction_Redemption();

                this.PostTransaction({
                ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
                })
                .then(res=>{
                    this.$store.dispatch('Logging',
                    {
                        typeid :'4', 
                        appid : '2',
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'PostTransaction (redeem)-> ' + this.StoreStateCD.FormDetails.ApplicationId + '. res --> ' + res.toString()
                    });
                   if(res!=true){
                            var tempScheme =''
                            var tempAmount = 0;
                          

                            
                        var Scheme = this.StoreStateCD.Transaction.Redemption.find(x=>x.count === this.tempCountLength).FundID
                        var Units = this.StoreStateCD.Transaction.Redemption.find(x=>x.count === this.tempCountLength).Units
                            for(var j=0; j<this.StoreStateCD.Holdings.length; j++){
                                if(this.StoreStateCD.Holdings[j].Scheme==this.Scheme ){

                                    if(this.StoreStateCD.Holdings[j].BalanceUnit === "0.00"){
                                        this.StoreStateCD.Holdings[j].BalanceUnit = Units
                                    }else{
                                        var temp = this.StoreStateCD.Holdings[j].BalanceUnit
                                        //.replace(",","")
                                        temp = temp
                                        //.replace(",","")
                                        temp = parseFloat(temp)
                                        this.StoreStateCD.Holdings[j].BalanceUnit = temp + Units // update value balance unit
                                        this.StoreStateCD.Holdings[j].BalanceUnit = this.StoreStateCD.Holdings[j].BalanceUnit.toFixed(2)
                            
                                    }
                                }
                            } 


                            for(var i=0; i<this.StoreStateCD.Transaction.Redemption.length; i++){
                                if(this.StoreStateCD.Transaction.Redemption[i].count=== this.tempCountLength){                                
                                    this.StoreStateCD.Transaction.Redemption.splice(i,1)
                                }
                            }

                            this.$q.loading.hide()
                            this.$q.dialog({
                                title: 'Error',
                                message:  res ,
                            })    
                    }else{

                        
                        this.$q.loading.hide()
                    
                    }
                }) 

            }
        },
        AddtoCart_Switching(){
            this.CreateTempId();
            this.CreateFundTransaction_Switching();
            this.PostTransaction({
               ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
            })
            .then(res=>{
                if(res==='error'){
                    this.$q.dialog({
                        title: 'Error',
                        message: 'Something went wrong. Please contact your administrator.',
                    })    
                }
                else{
                    this.SwitchingModal = false;
                }
            })
        },
        AddtoCart_Buy(){
            this.CreateTempId();
            this.CreateFundTransaction_Investment();
            this.PostTransaction({
               ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
            })
            .then(res=>{
                if(res==='error'){
                    this.$q.dialog({
                        title: 'Error',
                        message: 'Something went wrong. Please contact your administrator.',
                    })    
                }
                else{
                    this.TopupModal = false;
                }
            })
        },
        CreateFundTransaction_Investment(){
            this.StoreStateCD.Transaction.Investment.push({
                Id: this.TransactionId,
                Amount : this.$refs.refFTB.Form.InvAmount,
                SalesCharge : this.$refs.refFTB.Form.SalesCharge,
                SmartSave : this.$refs.refFTB.Form.SmartSave,
                SmartSaveStartDate : date.formatDate(this.$refs.refFTB.Form.SmartSaveStartDate, 'YYYY-MM-DD'),
                SmartSaveEndDate : date.formatDate(this.$refs.refFTB.Form.SmartSaveEndDate, 'YYYY-MM-DD'),
                ModeOfFrequency : this.$refs.refFTB.Form.ModeOfFrequency,
                DateOfDeduction : this.$refs.refFTB.Form.DateOfDeduction,
                FundID : this.Scheme,
                FundName : this.FundName,
                Plan : this.Plan,
                FundCurrency : this.FundCurrency,
                TypeOfProduct : this.StoreStateCD.Account.AccountType
            })
        },
        CreateFundTransaction_Redemption(){
            var SelItem = this.$refs.refFTR;
            // if(this.AccountType==='UTF'){
            //     SelItem = this.$refs.refFTR;
            // }
            // else
            // if(this.AccountType==='PRS'){
            //     SelItem = this.$refs.refFTRPRS;
            // }
            var count = this.StoreStateCD.Transaction.Redemption.length 
            this.tempCountLength = count + 1
            this.StoreStateCD.Transaction.Redemption.push({
                count :this.tempCountLength,
                Id: this.TransactionId,
                AmountOrUnit: SelItem.Form.AmountUnits,
                TypeOfProduct: this.ProductType,
                FundID: this.Scheme,
                FundName : this.FundName,
                Amount: SelItem.Form.Amount,
                PaymentInstruction: 'TT',
                BankAccountNumber: SelItem.Form.PaymentInstruction.value,
                Plan: SelItem.Form.Plan,
                Units: SelItem.Form.Units,
                FundCurrency: this.FundCurrency,
                RedeemAll : SelItem.Form.RedeemAllUnits,
                PRSWithdrawalReason : SelItem.Form.PRSWithdrawalReason.value,
                CuttOffTime : SelItem.Form.CutOffTime,
                ExpectedAmount : SelItem.Form.ExpectedAmount,
                BalanceUnits : SelItem.UnitsLeft
            })
        // alert(SelItem.Form.UnitsLeft)
         
    

            for(var j=0; j<this.StoreStateCD.Holdings.length; j++){
                if(this.StoreStateCD.Holdings[j].Scheme==this.Scheme ){
                    var tempAmount =""
                    tempAmount=SelItem.Form.Units.replace(",","");
                   //console.log('1 - >' + tempAmount)
                    tempAmount=tempAmount.replace(",","");
                   // console.log('2 - >' +tempAmount )
                    tempAmount= tempAmount.trim() 
                    //console.log('3 - >' +tempAmount )
                    parseFloat(tempAmount).toFixed(2)
                   //console.log('4 - >' + tempAmount)

                        this.StoreStateCD.Holdings[j].BalanceUnit = this.StoreStateCD.Holdings[j].BalanceUnit - tempAmount
                   
                    //.toFixed(2)
                    this.StoreStateCD.Holdings[j].BalanceUnit = this.StoreStateCD.Holdings[j].BalanceUnit.toFixed(2)

                }
            }

            this.$store.dispatch('Logging',
            {
                typeid :'5', 
                appid : '2',
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'CreateFundTransaction_Redemption (redeem), this.StoreStateCD.Transaction.Redemption  -> ' + this.StoreStateCD.Transaction.Redemption.length +' Trx id ->' + this.TransactionId
            });
},
        CreateFundTransaction_Switching(){ 
            var SelItem = this.$refs.refFTSW;
            if( SelItem.Form.PercUnits === 'Percentage'){
                SelItem.Form.Units = SelItem.Form.PercSwitchOut * this.BalanceUnit / 100
            }
            this.StoreStateCD.Transaction.Switching.push({
                Id: this.TransactionId,
                FromFundID: this.Scheme,
                FromFundName : this.FundName,
                Percentage: SelItem.Form.PercSwitchOut,
                ToFundID: SelItem.Form.SwitchFundCode,
                ToFundName: SelItem.Form.SwitchFundName,
                TypeOfProduct: this.ProductType,
                SalesCharge: SelItem.Form.SalesCharge,
                UnitsOrPercentage: SelItem.Form.PercUnits,
                Plan: this.Plan,
                Units: SelItem.Form.Units,
                FundCurrency: this.FundCurrency
            })

              this.$store.dispatch('Logging',{
                appid : '2',
                typeid :'4', 
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' CreateFundTransaction_Switching (switch),  this.StoreStateCD.Transaction.Switching - > '+  this.StoreStateCD.Transaction.Switching.length +' Trx id ->' + this.TransactionId
            });
        },
        CreateTempId() {
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c=='x' ? r :(r&0x3|0x8)).toString(16);
            });
            this.StoreStateCD.FormDetails.ApplicationId = uuid;
            this.TransactionId =  uuid;
        },
             
    }
}
</script>